/**
=========================================================

* Tazi Rides Ltd has developed this dashboard based on a further configured version of the original template.
* Website: https://www.tazirides.co.uk
* All rights reserved.

=========================================================
* Material Dashboard 2 PRO React TS - v1.0.2
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-2-pro-react-ts
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @material-ui core components
import React, { useContext } from 'react'

import Card from '@mui/material/Card'
import Grid from '@mui/material/Grid'

// Material Dashboard 2 PRO React TS components

import MDAvatar from 'components/MDAvatar'
import MDBox from 'components/MDBox'
import MDTypography from 'components/MDTypography'
import { useAuth } from 'context/auth'
import { FormContext } from 'layouts/organisation-member/constants'
import { OrganisationMember } from 'layouts/organisation-member/types'
import FormField from 'modules/FormField'

function Contact(): JSX.Element {
	const formContext = useContext(FormContext)
	const { user } = useAuth()
	const { localForm, setLocalForm, setFormEdited } = formContext

	const sectionDisabled = user.data.role === 'VIEWER'

	const handleFormUpdate = (value: string, field: keyof OrganisationMember['contact']) => {
		setLocalForm(prev => ({
			...prev,
			contact: {
				...prev.contact,
				[field]: value,
			},
		}))
		setFormEdited(true)
	}

	return (
		<Card id="contact">
			<MDBox display={'flex'} flexDirection={'row'} gap={2} p={3}>
				<MDAvatar bgColor="primary" size="xs">
					2
				</MDAvatar>
				<MDTypography variant="h5" fontWeight="medium">
					Contact
				</MDTypography>
			</MDBox>
			<MDBox component="form" pb={3} px={3}>
				<Grid container spacing={3}>
					<Grid item xs={12} sm={6} md={3}>
						<MDTypography variant="h6" fontWeight="medium">
							Phone Number
						</MDTypography>
						<FormField
							disabled={sectionDisabled}
							size="medium"
							value={localForm.contact.phoneNumber}
							onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
								handleFormUpdate(e.target.value, 'phoneNumber')
							}}
						/>
					</Grid>
					<Grid item xs={12} sm={6}>
						<MDTypography variant="h6" fontWeight="medium">
							Email
						</MDTypography>
						<FormField
							disabled={sectionDisabled}
							value={localForm.contact.email}
							onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
								handleFormUpdate(e.target.value, 'email')
							}}
						/>
					</Grid>
					<Grid item xs={12} sm={6} md={3}>
						<MDTypography variant="h6" fontWeight="medium">
							Badge
						</MDTypography>
						<FormField
							disabled={sectionDisabled}
							value={localForm.contact.badge}
							onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
								handleFormUpdate(e.target.value, 'badge')
							}}
						/>
					</Grid>
				</Grid>
			</MDBox>
		</Card>
	)
}

export default Contact
